module.exports = __webpack_public_path__ + "img/usuario.7ab5af7b.png";